<script>
  export let video
  import { createEventDispatcher } from 'svelte';
  import {update_video} from "./Utils/RouterUtils.svelte"
  import {fade} from 'svelte/transition';
  import { sidebarToggled } from "./Utils/stores";
  import SmallBlackCircleTick from "./SmallBlackCircleTick.svelte";
  const dispatch = createEventDispatcher();

  function videoClicked() {
      dispatch('video-clicked');
  }
  
  function toggle_sidebar() {
    if(window.innerWidth < 768) {
      if(sidebarState) {
        sidebarToggled.update(sidebarToggled => false);
      } else {
        sidebarToggled.update(sidebarToggled => true);
      }
    }
  }

  let sidebarState;

	sidebarToggled.subscribe((value) => {
		sidebarState = value;
	});
</script>
<div >
  <div class="downline vec-bg-midGrey" aria-hidden="true"></div>
    <div
            id={video.slug.current}
            in:fade="{{delay: 0,  duration: 200}}"
            on:click={update_video(video.slug.current), videoClicked(), toggle_sidebar()} >
  <a href="#" class="item__wrapper">
       <SmallBlackCircleTick />
    <span class="item__title_wrapper">
          <span class="item__title text-dark">{video.videoTitle}</span>
          <span class="item__subtitle">
            {video.shortDescription}
          </span>
        </span>
  </a>
        </div>
</div>
<style>



    .downline {
        width: 0.125rem;
        left: 1rem;
        top: 1rem;
        position: absolute;
        margin-left: -1px;
        margin-top: 0.125rem;
        height: 100%;
    }


    .item__wrapper {
        position: relative;
        align-items: flex-start;
        display: flex;
    }

    .item__title_wrapper {
        min-width: 0px;
        margin-left: 1rem;
        display: flex;
        flex-direction: column;
    }

    .item__title {
        letter-spacing: 0.025em;
        font-size: 1rem;
        line-height: 1.25rem;
        font-weight: 700;
        font-family: Raleway, sans-serif;
    }

    .item__subtitle {
        color: #3a3a3a;
        font-size: 0.875rem;
        line-height: 1.25rem;
    }


    .item__wrapper {
        text-decoration: none;
    }

</style>
